import React from "react";
import { Box } from "@mui/material";
import { TIERS } from "../../constants/membership";
import MMPreferencesTab from "./MMPreferencesTab";
import CountryFilterTab from "./CountryFilterTab";
import PremiumOnlyOverlay from "./PremiumOnlyOverlay";
import { shouldShowPremiumMatchFiltersPrompt } from "./premiumMatchFiltersGate";
import { SETTINGS_FULL_DIVIDER_SX } from "./lobbySettingsStyles";

export default function MatchFiltersTab({
    matchmakingOptions = {},
    onMatchmakingOptionChange,
    onLeaderMatchmakingUpdate,
    canEditLobbySettings = false,
    currentLobbyCode = null,
    isMatchmakingEditingDisabled = false,
    membershipTier = TIERS.FREE,
    currentUserGender = null,
    playerCountry = null,
    settingsResetVersion = 0,
}) {
    const showPremiumGate = shouldShowPremiumMatchFiltersPrompt({
        membershipTier,
        currentLobbyCode,
        canEditLobbySettings,
    });

    return (
        <Box
            sx={{
                position: "relative",
                ...(showPremiumGate
                    ? {
                          flex: 1,
                          minHeight: 0,
                          overflow: "hidden",
                      }
                    : undefined),
            }}
        >
            <Box
                sx={
                    showPremiumGate
                        ? {
                              opacity: 0.4,
                              pointerEvents: "none",
                              userSelect: "none",
                          }
                        : undefined
                }
            >
                <MMPreferencesTab
                    matchmakingOptions={matchmakingOptions}
                    onMatchmakingOptionChange={onMatchmakingOptionChange}
                    onLeaderMatchmakingUpdate={onLeaderMatchmakingUpdate}
                    canEditLobbySettings={canEditLobbySettings}
                    currentLobbyCode={currentLobbyCode}
                    isMatchmakingEditingDisabled={isMatchmakingEditingDisabled}
                    membershipTier={membershipTier}
                    currentUserGender={currentUserGender}
                    settingsResetVersion={settingsResetVersion}
                    hidePremiumOverlay
                />
                <Box sx={SETTINGS_FULL_DIVIDER_SX} />
                <CountryFilterTab
                    matchmakingOptions={matchmakingOptions}
                    onMatchmakingOptionChange={onMatchmakingOptionChange}
                    onLeaderMatchmakingUpdate={onLeaderMatchmakingUpdate}
                    canEditLobbySettings={canEditLobbySettings}
                    currentLobbyCode={currentLobbyCode}
                    isMatchmakingEditingDisabled={isMatchmakingEditingDisabled}
                    membershipTier={membershipTier}
                    settingsResetVersion={settingsResetVersion}
                    hidePremiumOverlay
                    playerCountry={playerCountry}
                />
            </Box>
            {showPremiumGate ? <PremiumOnlyOverlay /> : null}
        </Box>
    );
}
